import { odemeSaglayiciKarti } from "../components/receipts.js";
import { aktarimKarti } from "../components/export.js";
import { kanalKarti } from "../components/notifications.js";
import { plan } from "../domain/billing.js";
import { kvkkKarti } from "../components/kvkk.js";
import { yapabilir } from "../domain/auth.js";
import { subeBelgeKarti } from "../components/documents.js";
import { B, T } from "../domain/context.js";
import { card, classChip, emptyNote, sectionTitle } from "../components/ui.js";
import { davetKarti } from "./davetler.js";
import { esc, money } from "../lib/fmt.js";
import { denetimIzi, depoAdi, depoUyarisi, gunlukBoyu } from "../repo/index.js";

// ---------- AYARLAR ----------
export function viewAyarlar() {
  const t = B();
  return `
  <div class="grid gap-4 lg:grid-cols-2">
    ${card(`
      <div class="p-5">
        ${sectionTitle("Şube Bilgileri")}
        <dl class="space-y-3 text-sm">
          <div><dt class="text-[11px] font-bold text-inksoft uppercase">Şube Adı</dt><dd class="font-semibold">${esc(T().name)} — ${esc(t.name)}</dd></div>
          <div><dt class="text-[11px] font-bold text-inksoft uppercase">Adres</dt><dd>${esc(t.address)}</dd></div>
          <div><dt class="text-[11px] font-bold text-inksoft uppercase">Telefon</dt><dd>${esc(t.phone)}</dd></div>
          <div><dt class="text-[11px] font-bold text-inksoft uppercase">Abonelik</dt>
            <dd>
              <span class="text-[11px] font-bold rounded-full bg-grape-soft text-grape px-2.5 py-1">${esc(plan().label)}</span>
              <a href="#/abonelik" class="text-[11px] text-teal font-semibold hover:underline ml-1">ayrıntı →</a>
            </dd>
            <dd class="text-[11px] text-inksoft mt-0.5">Abonelik kurum geneli için tektir, şube başına değil.</dd></div>
        </dl>
      </div>`)}

    ${card(`
      <div class="p-5">
        ${sectionTitle("Dönem & Servis")}
        <dl class="space-y-3 text-sm">
          <div><dt class="text-[11px] font-bold text-inksoft uppercase">Aktif Dönem</dt><dd class="font-semibold">2025–2026 Yaz Dönemi</dd></div>
          <div><dt class="text-[11px] font-bold text-inksoft uppercase">Servis Ücreti</dt><dd class="font-semibold">${money(t.serviceFee)} / ay</dd></div>
          <div><dt class="text-[11px] font-bold text-inksoft uppercase">Çalışma Saatleri</dt><dd>Hafta içi 07:30 – 18:30</dd></div>
          <div><dt class="text-[11px] font-bold text-inksoft uppercase">Yarım Gün Çıkış</dt><dd>12:30 – 13:00 arası</dd></div>
        </dl>
      </div>`)}

    ${card(`
      <div class="p-5">
        ${sectionTitle("Sınıf Bazlı Ücret Tarifesi", `<span class="text-[11px] text-inksoft hidden sm:block">Her sınıf kendi ücretini taşır — yaş grubu küçüldükçe öğretmen oranı artar</span>`)}
        <div class="overflow-x-auto">
          <table class="w-full text-sm min-w-[560px]">
            <thead><tr class="text-left text-[11px] uppercase tracking-wide text-inksoft border-b border-line">
              <th class="py-2.5 pr-4">Sınıf</th><th class="py-2.5 pr-4">Yaş</th><th class="py-2.5 pr-4">Öğretmen Oranı</th>
              <th class="py-2.5 pr-4">Tam Gün</th><th class="py-2.5 pr-4">Yarım Gün</th><th class="py-2.5">Servis Dahil</th></tr></thead>
            <tbody class="divide-y divide-line/70">
              ${t.classes.map(c => `
                <tr>
                  <td class="py-3 pr-4">${classChip(c.id)}</td>
                  <td class="py-3 pr-4 text-inksoft whitespace-nowrap">${c.age}</td>
                  <td class="py-3 pr-4 text-inksoft whitespace-nowrap">${esc(c.ratio)}</td>
                  <td class="py-3 pr-4 font-semibold whitespace-nowrap">${money(c.tuition)}</td>
                  <td class="py-3 pr-4 whitespace-nowrap">${money(c.tuitionHalf)}</td>
                  <td class="py-3 text-inksoft whitespace-nowrap">${money(c.tuition + t.serviceFee)}</td>
                </tr>`).join("")}
            </tbody>
          </table>
        </div>
        <div class="mt-4 grid gap-2 sm:grid-cols-2">
          <div class="rounded-xl bg-teal-soft p-3 text-sm">
            <div class="text-[11px] font-bold text-teal uppercase">Kardeş İndirimi</div>
            <div class="mt-0.5">Aynı velinin ikinci ve sonraki çocuğunda toplam tutardan %10</div>
          </div>
          <div class="rounded-xl bg-grape-soft p-3 text-sm">
            <div class="text-[11px] font-bold text-grape uppercase">Personel Çocuğu</div>
            <div class="mt-0.5">Kurum personelinin çocuğunda toplam tutardan %50</div>
          </div>
        </div>
      </div>`, "min-w-0 lg:col-span-2")}

    ${davetKarti(t.id)}

    ${card(kanalKarti(t.id), "min-w-0")}
    ${card(odemeSaglayiciKarti(), "min-w-0")}
    ${aktarimKarti()}
    ${kvkkKarti(t.id)}
    ${subeBelgeKarti(t.id)}
    ${veriDeposuKarti()}
    ${yapabilir("denetimIziGor") ? denetimIziKarti(t) : ""}
  </div>`;
}

// ---------- Veri deposu (§1) ----------
function veriDeposuKarti() {
  const yerel = depoAdi() === "local";
  const uyari = depoUyarisi();

  return card(`
    <div class="p-5">
      ${sectionTitle("Veri Deposu")}
      <div class="flex items-center gap-3">
        <span class="w-2.5 h-2.5 rounded-full ${yerel ? "bg-sun" : "bg-teal"} shrink-0"></span>
        <div class="min-w-0">
          <div class="text-sm font-semibold">${yerel ? "Yerel depo (bu cihaz)" : "Firestore — bulut"}</div>
          <div class="text-[11px] text-inksoft">
            ${yerel
              ? "Değişiklikler tarayıcıda saklanıyor. Başka cihazdan görünmez."
              : "Değişiklikler bulutta; tüm cihazlarda anında görünür."}
          </div>
        </div>
        <span class="ml-auto text-[11px] font-bold text-inksoft shrink-0">${gunlukBoyu()} kayıt</span>
      </div>

      ${yerel ? `
        <div class="mt-3 rounded-xl bg-sun-soft text-[#B07E14] text-xs p-3">
          Buluta geçmek için <code class="font-mono">.env.example</code> dosyasını
          <code class="font-mono">.env</code> olarak kopyalayıp Firebase proje bilgilerini girin.
          Uygulama açılışta kendiliğinden Firestore'a bağlanır.
        </div>` : ""}

      ${uyari ? `<div class="mt-3 rounded-xl bg-coral-soft text-coral text-xs font-semibold p-3">${esc(uyari)}</div>` : ""}
    </div>`, "min-w-0");
}

// ---------- Denetim izi (§8) ----------
const IZ_ETIKET = {
  attendance: { ad: "Yoklama", renk: "teal" },
  message: { ad: "Mesaj", renk: "sky" },
  staff: { ad: "Personel", renk: "grape" },
  class: { ad: "Sınıf", renk: "grape" },
  application: { ad: "Başvuru", renk: "sun" },
  student: { ad: "Öğrenci", renk: "coral" },
};

function denetimIziKarti(t) {
  const kayitlar = denetimIzi({ branchId: t.id, limit: 12 });

  return card(`
    <div class="p-5">
      ${sectionTitle("Denetim İzi", `<span class="text-[11px] text-inksoft hidden sm:block">Kim, ne zaman, neyi değiştirdi</span>`)}

      ${kayitlar.length ? `
        <ol class="space-y-2">
          ${kayitlar.map(m => {
            const e = IZ_ETIKET[m.entity] ?? { ad: m.entity, renk: "grape" };
            return `
            <li class="flex items-start gap-3 rounded-xl border border-line px-3 py-2.5">
              <span class="text-[10px] font-bold rounded-full bg-${e.renk}-soft text-${e.renk} px-2 py-0.5 shrink-0 mt-0.5">${esc(e.ad)}</span>
              <span class="min-w-0 flex-1">
                <span class="block text-sm truncate">${esc(m.label)}</span>
                <span class="block text-[11px] text-inksoft">${esc(m.actor?.name ?? "—")} · ${zamanMetni(m.at)}</span>
              </span>
            </li>`;
          }).join("")}
        </ol>
        <p class="text-[11px] text-inksoft/80 mt-3">
          Kayıtlar değiştirilemez ve silinemez. Düzeltme yalnızca ters kayıtla yapılır.
        </p>`
        : emptyNote("Bu şubede henüz kayıtlı değişiklik yok. Yoklama alın veya mesaj gönderin.")}
    </div>`, "min-w-0");
}

function zamanMetni(iso) {
  const d = new Date(iso);
  return d.toLocaleString("tr-TR", {
    day: "numeric", month: "long", hour: "2-digit", minute: "2-digit",
  });
}

